module.exports = __webpack_public_path__ + "static/TechSnowmobile-b78e7b901ec85d367067d7b294e36a3b.jpg";